import styled, { css } from 'vue-styled-components'

const TemplateColor = (templateColor = {}) => {
  return css`
  ${Object.entries(templateColor).map(([key, val]) => `${key}: ${val}`).join(';')}
  `
}

const ContentWrapperProps = {
  templateColor: Object,
}
const ContentWrapper = styled('div', ContentWrapperProps)`
> * {
  ${({ templateColor }) => TemplateColor(templateColor)}
 }
.b-sidebar{
  height: calc(100% - 56px);
  top: 56px;
  & .b-sidebar {
    top: 0px;
    height: 100%;
  }
}
@media only screen and (max-width: 1139px)   {
  .b-sidebar{
    height: calc(100% - 112px);
    top: 112px;
  }
}
`;

const MainBody = styled.div`
    height: calc(100% - 56px);
    @media only screen and (max-width: 1139px)   {
      height: calc(100% - 112px);
    }
  `;
const SidebarWrapper = styled.div`
    /* overflow-y: scroll; */
    border-right: 1px solid var(--line);
  `;
const SidebarContainer = styled.div`
    width: var(--sidebar-width);
    .b-sidebar {
      width: var(--sidebar-width);
      background-color: #fff;
    }
  `;
export {
  ContentWrapper,
  MainBody,
  SidebarWrapper,
  SidebarContainer
}